import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const BankingBreakdownStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
      // padding: "20px 25px",
      // borderRadius: "4px",
      // width: "100%",
      // border: "solid 1px #00000020",
    },
    copy: {
      width: "120px",
      height: "40px",
      position: "fixed !important" as "fixed",
      bgcolor: "background.paper",
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      borderRadius: 15,
    },
    icon: {
      display: "flex",
      backgroundColor: theme.palette.background.default,
      textAlign: "center",
      justifyContent: "flex-end",
      cursor: "pointer",
      fontWeight: "bold",
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.main,
      textTransform: "none",
      fontSize: "0.8rem",
      "&:hover": {
        borderColor: theme.palette.secondary.main,
        background: "#FFF6F6",
      },
    },
    currencyContainer: {
      textAlign: "center",
      justifyContent: "center",
      cursor: "pointer",
      paddingBottom: "16px",
    },
    title: {
      fontSize: "20px",
      fontWeight: theme.typography.fontWeightBold,
    },
    symbol: {
      fon0ize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: "10px",
    },
    placeHolder: {
      color: theme.palette.text.secondary,
      fontSize: "1rem",
      fontWeight: theme.typography.fontWeightRegular,
    },
    content: {
      fontSize: "1rem",
      fontWeight: theme.typography.fontWeightMedium,
    },
    description: {
      fontSize: "0.8rem",
      fontWeight: theme.typography.fontWeightRegular,
      fontStyle: "italic",
      color: "#7B858B",
    },

    message: {
      fontSize: "16px",
      color: "#545454",
      fontWeight: theme.typography.fontWeightRegular,
    },

    listItem: {
      display: "flex",
      alignItems: "center",
    },

    listItemNumber: {
      marginRight: "1rem",
      width: "28px",
      lineHeight: "28px",
      borderRadius: "50%",
      textAlign: "center",
      border: "1px solid",
    },
  }),
);
